import { render, staticRenderFns } from "./dialogVerifyOtp-microsite.vue?vue&type=template&id=3584f968"
import script from "./dialogVerifyOtp-microsite.vue?vue&type=script&lang=js"
export * from "./dialogVerifyOtp-microsite.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports